// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"58c601b2","360":"c76754d7","370":"d50b3b2e","453":"d1994899","834":"8ce49076"}[chunkId] + ".chunk.js";
};